











































































































































import { Component, Vue } from "vue-property-decorator";
import { Empty } from "vant";

@Component({
  components: {
    [Empty.name]: Empty
  }
})
export default class FundsDetails extends Vue {
  detailData: any = {};
  defaultMoney = "0.00";
  requestFail = false;
  IMG_NET_ERR = (this as any).IMG_NET_ERR;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getFundsDetailData();
  }

  formatMoney(money, len) {
    if (!money && money != 0) return "0.00";
    if (isNaN(+money)) return "0.00";
    len = len || 2;
    const arr = (money + "").split(".");
    const intStr = arr[0] ? arr[0] : 0;
    let floatStr = arr[1] ? arr[1] : 0;
    if (floatStr == 0) {
      floatStr = "0";
      for (let i = 0; i < len - 1; i++) {
        floatStr += "0";
      }
    } else {
      floatStr = (+("0." + floatStr)).toFixed(len).split(".")[1];
    }
    money = (intStr + "." + floatStr).replace(
      /(\d{1,3})(?=(?:\d{3})+\.)/g,
      "$1,"
    );
    return money;
  }

  getFundsDetailData() {
    (this as any).$apis
      .getAccountBalanceDetails({ type:this.$route.query.account_type,account_no:this.$route.query.account_no })
      .then(res => {
        this.requestFail = false;
        if (this.$route.query.account_type && Number(this.$route.query.account_type)) {
          this.detailData = res.qh;
        }
      })
      .catch(() => {
        this.requestFail = true;
      });
  }
}
